import Cookies from 'js-cookie'

export function saveIccid (query) {
  Cookies.set('Iccid', query)
  return true
}

export function saveHomeUrl (query) {
  Cookies.set('HomeUrl', query)
  return true
}

export function saveLoginStatus (query) {
  Cookies.set('LoginStatus', query)
  return true
}

export function saveCn (query) {
  Cookies.set('Cn', query)
  return true
}

export function saveType (query) {
  Cookies.set('Type', query)
  return true
}

export function savePrepare (query) {
  Cookies.set('Prepare', query)
  return true
}

export function saveToken (query) {
  Cookies.set('Token', query)
  return true
}

export function saveCerUrl (query) {
  Cookies.set('CerUrl', query)
  return true
}

export function saveOpenid (query) {
  Cookies.set('Openid', query)
  return true
}

export function saveAppid (query) {
  Cookies.set('Appid', query)
  return true
}

export function saveTemplate (query) {
  Cookies.set('Template', query)
  return true
}

export function saveRedirected (query) {
  Cookies.set('Redirected', query)
  return true
}

export function loadLoginStatus (query) {
  return isNaN(Number(Cookies.get('LoginStatus'))) ? 0 : Cookies.get('LoginStatus')
}

export function loadCn () {
  return Cookies.get('Cn')
}

export function loadHomeUrl () {
  return Cookies.get('HomeUrl')
}

export function loadType () {
  return Cookies.get('Type')
}

export function loadPrepare () {
  return Cookies.get('Prepare')
}

export function loadToken () {
  return Cookies.get('Token')
}

export function loadIccid () {
  return Cookies.get('Iccid')
}

export function loadCerUrl () {
  return Cookies.get('CerUrl')
}

export function loadOpenid () {
  return Cookies.get('Openid')
}

export function loadAppid () {
  return Cookies.get('Appid')
}

export function loadTemplate () {
  return Cookies.get('Template')
}

export function loadRedirected () {
  return Cookies.get('Redirected')
}

export function removeLoginStatus () {
  return Cookies.remove('LoginStatus')
}

export function removeCn () {
  return Cookies.remove('Cn')
}

export function removeHomeUrl () {
  return Cookies.remove('HomeUrl')
}

export function removeType () {
  return Cookies.remove('Type')
}

export function removePrepare () {
  return Cookies.remove('Prepare')
}

export function removeToken () {
  return Cookies.remove('Token')
}

export function removeIccid () {
  return Cookies.remove('Iccid')
}

export function removeCerUrl () {
  return Cookies.remove('CerUrl')
}

export function removeOpenid () {
  return Cookies.remove('Openid')
}

export function removeAppid () {
  return Cookies.remove('Appid')
}

export function removeTemplate () {
  return Cookies.remove('Appid')
}

export function removeRedirected () {
  return Cookies.remove('Redirected')
}



// WEBPACK FOOTER //
// ./src/utils/cache.js